
export const BID_STATUS = {
  CREATED: 'Criado',
  RUNNING: 'Em andamento',
  FINISHED: 'Finalizado',
  PENDING: 'Pendente',
  ACTIVE: 'Ativo',
  WAITING_APPROVE: 'Aguardando aprovação',
}

export const BID_STATUS_COLOR = {
  CREATED: '#828282',
  RUNNING: '#F4B000',
  FINISHED: '#27AE60',
  WAITING_APPROVE: '#2D9CDB',
}

export const ENRROLMENT_STATUS = {
  PENDING: 'Pendente',
  ACTIVE: 'Ativo',
}

export const ENRROLMENT_STATUS_COLOR = {
  PENDING: '#F2C94C',
  ACTIVE: '#27AE60',
}

export const BID_PAGINATION_SIZE = 20

